import { Slider as MuiSlider, styled } from '@mui/material';

export const Slider = styled(MuiSlider)(({ theme: { palette } }) => ({
  marginLeft: `10px !important`,
  marginRight: `10px !important`,
  width: 'calc(100% - 20px) !important',
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: palette.slider.thumb.background.default,
    border: `1px solid ${palette.slider.thumb.border}`,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.slider.thumb.background.hover,
      boxShadow: 'none',
    },
    '&:active, &:focus-within': {
      boxShadow: palette.slider.thumb.active,
    },
  },
  '& .MuiSlider-track': {
    height: 5,
    border: 'none',
    borderRadius: '2px',
    backgroundColor: `${palette.slider.track.default} !important`,
    opacity: 1,
  },
  '& .MuiSlider-rail': {
    height: 5,
    borderRadius: '2px',
    color: palette.slider.rail.default,
    opacity: 1,
  },
  '&.Mui-disabled': {
    '& .MuiSlider-thumb': {
      cursor: 'default',
      backgroundColor: palette.input.background.disabled,
      borderColor: palette.input.border.disabled,
    },
    '& .MuiSlider-track': {
      backgroundColor: palette.slider.track.disabled,
    },
    '& .MuiSlider-rail': {
      color: palette.slider.rail.disabled,
    },
  },
  '& .MuiSlider-markLabel': {
    color: palette.input.label.disabled,
  },
  '& .MuiSlider-markLabelActive': {
    color: palette.input.label.default,
  },
}));
